import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './OurApproach.scss';

const OurApproach = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [isVisible, setIsVisible] = useState(true);
    const [sectionVisible, setSectionVisible] = useState(false);
    const sectionRef = useRef(null);

    const steps = [
        {
            id: 1,
            title: 'Discovery & Insight',
            description: 'Understanding your business, market, and goals',
        },
        {
            id: 2,
            title: 'Strategy & Planning',
            description: 'Data-led planning across channels',
        },
        {
            id: 3,
            title: 'Execution & Optimisation',
            description: 'SEO, Paid Media, Creative & CRO',
        },
        {
            id: 4,
            title: 'Measurement & Scale',
            description: 'Clear reporting, continuous improvement',
        }
    ];

    // Intersection Observer for section visibility
    useEffect(() => {
        const currentSection = sectionRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setSectionVisible(true);
                } else {
                    setSectionVisible(false);
                }
            },
            {
                threshold: 0.2,
                rootMargin: '0px'
            }
        );

        if (currentSection) {
            observer.observe(currentSection);
        }

        return () => {
            if (currentSection) {
                observer.unobserve(currentSection);
            }
        };
    }, []);

    // Step rotation - only runs when section is visible
    useEffect(() => {
        if (!sectionVisible) return;

        const interval = setInterval(() => {
            // Fade out current step
            setIsVisible(false);

            // After fade out, change step and fade in
            setTimeout(() => {
                setCurrentStep((prev) => (prev + 1) % steps.length);
                setIsVisible(true);
            }, 500); // Half second for fade out
        }, 3000); // 3 seconds total (2.5s visible + 0.5s transition)

        return () => clearInterval(interval);
    }, [steps.length, sectionVisible]);

    return (
        <div
            ref={sectionRef}
            className={`approach-section-wrapper ${sectionVisible ? 'approach-section-visible' : ''}`}
        >
            {/* Wavy Background */}
            <div className={`approach-wavy-bg ${sectionVisible ? 'approach-animated' : ''}`}>
                <div className="approach-wave approach-wave1"></div>
                <div className="approach-wave approach-wave2"></div>
                <div className="approach-wave approach-wave3"></div>
            </div>

            <div className="approach-title-container text-center mb-5">
                <h2 className={`approach-main-title ${sectionVisible ? 'approach-animated' : ''}`}>
                    Our Approach
                </h2>
                <h3 className={` subtitle ${sectionVisible ? 'approach-animated' : ''}`}>
                    A systematic process that delivers measurable results
                </h3>
            </div>

            {/* Single Step Container */}
            <div className="approach-step-wrapper">
                <div className={`approach-step-content ${isVisible && sectionVisible ? 'approach-fade-in' : 'approach-fade-out'}`}>
                    <Row className="align-items-center justify-content-center">
                        <Col lg="10" className="text-center approach-step-details">
                            <h3 className={`approach-step-title ${sectionVisible ? 'approach-animated' : ''}`}>
                                {steps[currentStep].title}
                            </h3>
                            <p className={`approach-step-description ${sectionVisible ? 'approach-animated' : ''}`}>
                                {steps[currentStep].description}
                            </p>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default OurApproach;